import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { trackPageView } from "../../../services/commons";
import { TRACK } from "../../constants";
import useStyles from "./styles";
import Button from "@mui/material/Button";
import { getTranslation } from "../../../locales";

const Welcome = (props) => {
  const { greetings, currentTheme } = useSelector((state) => state.survey);
  const styles = useStyles({ ...props, currentTheme });

  useEffect(() => {
    trackPageView(TRACK.PAGE.SURVEYTAKER_OPENED);
  }, []);

  const welcomeText =
    greetings && greetings.title
      ? greetings.title
      : getTranslation(props.currentLang, "surveyTaker:welcome");

  return (
    <div className={styles.container}>
      {greetings && greetings.image_url && (
        <div className={styles.surveyEndImage}>
          <img src={greetings.image_url} />
        </div>
      )}
      <div className={styles.welcomeHeader}>
        <span> {welcomeText} </span>
      </div>
      <div className={styles.welcomeMessage}>
        <span>
          {" "}
          {(greetings && greetings.description) ||
            getTranslation(
              props.currentLang,
              "surveyTaker:thanksForTakingPart"
            )}{" "}
        </span>
      </div>
      <div>
        <Button
          data-testid="welcome-done-btn"
          onClick={props.welcomeDone}
          className={styles.redirectBtn}
          style={{
            backgroundColor: currentTheme.primaryColor,
            color: currentTheme.fontColor,
          }}
        >
          {" "}
          {getTranslation(props.currentLang, "surveyTaker:getStarted")}{" "}
        </Button>
      </div>
    </div>
  );
};

export default Welcome;
